/* eslint-disable import/prefer-default-export */
import { message as alert } from "@wellth/web-ui";

export const handlePhoneNumberError = (message: string): void => {
  if (!message) {
    void alert.error("An error occured.");
  }
  void alert.error(message);
};
